export default function Certificates() {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">🏅 Certificates</h2>
      <p>View or download your completion certificate here.</p>
    </div>
  );
}
